import React, { useState } from 'react';
import { without } from 'lodash';
import { useParams } from 'react-router-dom';

import CardLayout from '@magoosh/layouts/card';

import Response from '../../../components/response';
import { ScoreReportResponse } from '../../../types';

interface Props {
  responses: ScoreReportResponse[];
}

export default (props: Props) => {
  const { answerId } = useParams();
  const [expandOtherResponses, setExpandOtherResponses] = useState<boolean>(false);
  const [volume, setVolume] = useState(1);

  const highlightedResponse = props.responses.find((response) => response.answer.id === parseInt(answerId));

  if (highlightedResponse) {
    const otherResponses = without(props.responses, highlightedResponse);

    return (
      <div className="d-flex flex-1 flex-column gap-m">
        <CardLayout.Card>
          <Response
            analysisExpandedByDefault
            displayStimulusImage
            offerRetry
            response={highlightedResponse}
            setVolume={setVolume}
            volume={volume}
          />
        </CardLayout.Card>

        {
          !!otherResponses.length && (
            <>
              <div className="d-flex flex-column gap-s gap-lg-m">
                <div className="align-items-end d-flex">
                  <h3 className="flex-1 u-margin-A-n u-margin-T-s">
                    <strong>Other Related Responses</strong>
                  </h3>

                  <div
                    className="small text-secondary"
                    onClick={() => setExpandOtherResponses(true)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>Expand All Responses</strong>
                  </div>
                </div>

                <hr className="u-margin-A-n" />
              </div>

              {
                otherResponses.map((response) => {
                  if (expandOtherResponses) {
                    return (
                      <CardLayout.Card key={response.id}>
                        <Response
                          displayStimulusImage
                          offerRetry
                          response={response}
                          setVolume={setVolume}
                          volume={volume}
                        />
                      </CardLayout.Card>
                    );
                  } else {
                    return (
                      <CardLayout.Card key={response.id} className="d-flex gap-s gap-md-l">
                        <div
                          className="flex-1"
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {response.answer.prompt.content.audio?.transcript}
                        </div>

                        <div>
                          Score <strong>{response.score}</strong>
                        </div>
                      </CardLayout.Card>
                    );
                  }
                })
              }
            </>
          )
        }
      </div>
    );
  } else {
    return (
      <div className="d-flex flex-1 flex-column gap-m">
        {
          props.responses.map((response) => {
            return (
              <CardLayout.Card key={response.id}>
                <Response
                  displayStimulusImage
                  offerRetry
                  response={response}
                  setVolume={setVolume}
                  volume={volume}
                />
              </CardLayout.Card>
            );
          })
        }
      </div>
    );
  }
};
